class MiniBasketClass {

    constructor() {
        this.count = 0;
        this.items = [];
    }

    load = () => {

        // Load Data from minibasket_ajax and update settings.
        return fetch( '/index.php?cl=minibasket_ajax', {
            method: 'GET',
            credentials: 'include',
            mode: 'no-cors',
        } )
        .then( response => response.json() )
        .then( response => {
            this.updateWith( response.data )
            return response;
        } );
    };

    reload = () => {
        return this.load().then( data => this.onUpdate( data ) );
    };

    updateWith = ( data ) => {
        this.count = data.itemCount;
        this.items = data.itemData;
    };

    onUpdate( response ) {

        // So the updating JS Logic does not break our promise.
        try {
            this.setBasketCount();
            this.setBasketReminderContent();
            this.showBasketReminderContent();

			if (window.ReactNativeWebView) {
				window.ReactNativeWebView.postMessage("basket::update");
			}

            window.dispatchEvent( new CustomEvent( 'minibasket_updated.acl', {
                detail: {
                    basketCount: this.count,
                    basketItems: this.items,
                }
            } ) );
        } catch ( err ) {
            console.error( err ); // eslint-disable-line no-console
        }

        return response;
    }

    setBasketCount = () => {
        const count = this.count;

        // Prepare Cart Head.
        const cartEl = document.getElementById( 'acl_js--cart_items' );
        if ( ! cartEl ) {
            return;
        }

        // Remove count Element.
        cartEl.querySelectorAll( '.mdl_header__user-nav-item-count' ).forEach( countEl => countEl.remove() );

        if ( count === 0 ) {
            return;
        }

        // Re-Add Item count.
        cartEl.firstElementChild.insertAdjacentHTML( 'afterbegin', `<span class="mdl_header__user-nav-item-count">${ count }</span>` );
    };

    setBasketReminderContent = () => {
        const items = this.items;
        const count = this.count;

        const cartreminderEl = document.querySelector( '.mdl_cartreminder' );
        if ( ! cartreminderEl ) {
            return;
        }

        // Article List.
        const articleContainerEl = cartreminderEl.querySelector( '.articles' );

        // Clear Container.
        Array.from( articleContainerEl?.children || [] ).filter( articleEl => articleEl.matches( 'article' ) ).forEach( articleEl => articleEl.remove() );

        // Add new articles.
        for ( let i = 0; i < items.length; i++ ) {
            let article = `<article class="article">
                <div class="article_image_wrapper">
                    <img class="article_image" src="${items[i]['img']}" width="82" height="110" alt="">
                </div>
                <section class="article_text_wrapper">
                    <div class="article_name">
                        <div class="article_label">${items[i]['title']}</div>
                        ${items[i]['desc']}
                    </div>
                </section>
            </article>`;
            articleContainerEl.insertAdjacentHTML( 'beforeend', article );

            if ( i === 2 ) {
                break;
            }
        }

        // Show weitere Articles if needed.
        const moreTextEl = cartreminderEl.querySelector( '.morearticlestext' );
        if ( moreTextEl ) {
            moreTextEl.innerText = '';
            if ( items.length > 3 ) {
                const others = items.length - 3;
                moreTextEl.innerText = `...und ${ others } ${ others === 1 ? 'weiterer' : 'weitere' } Artikel`;
                moreTextEl.classList.remove( 'en_hidden' );
            } else {
                moreTextEl.classList.add( 'en_hidden' );
            }
        }
    };

    showBasketReminderContent = () => {
        const count = this.count;
        if ( count > 0 ) {
            window.dispatchEvent( new CustomEvent( 'showcartreminder.acl' ) );
        } else {
            EN.Cookies.remove( 'closedcartreminder' );
        }
    };

    async addArticleBySku( sku, amount = 1 ){
        const promise = this.submitForm( {
            'cl': 'minibasket_ajax',
            'fnc': 'tobasket',
            'aid': sku,
            'anid': sku,
            'am': amount,
        } );

        // Try to update basket data.
        return await promise
            .catch( res => res )
            .then( ( response ) => {
                if ( response && response.data ) {
                    // Try to update basket.
                    this.updateWith( response.data )
                    this.onUpdate()
                }

                // Return original Promise, so we don't lose status in case of rejection.
                return promise;
            } )
    }

    async submitForm( dataParams ) {

        // Get Params and add ajax.
        const params = new URLSearchParams( dataParams );
        params.set( 'ajax', '1' );

        const pAid = params.get( 'aid' );
        const pAnid = params.get( 'anid' );

        // Ajax call to check if there are less than 9 same articles in the basket.
        const amountIsValid = await fetch( '/index.php?cl=minibasket_ajax&fnc=checkProductLimitForBasket&ajax=1&aid=' + pAid )
            .then( async ( response ) => {
                return ( await response.text() ).includes( 'true' );
            });

        if ( pAnid.indexOf( '0' ) < 1 || amountIsValid === false ) {
            return Promise.reject({
                "error": [
                    {
                        "error": 500,
                        "message": "Der Artikel konnte nicht hinzugefügt werden!"
                    }
                ]
            });
        }

        return await fetch( '/index.php', {
            method: 'POST',
            body: params,
        }).then( async ( response ) => {
            if ( response.ok ) {
                try {
                    return await response.json();
                } catch( err ) {
                    return true;
                }
            }

            try {
                return Promise.reject( await response.json() );
            } catch ( err ) {
                return Promise.reject({
                    "error": [
                        {
                            "error": response.status,
                            "message": "Der Artikel konnte nicht hinzugefügt werden!"
                        }
                    ]
                })
            }
        });
    }
}

const MiniBasket = new MiniBasketClass();

export default MiniBasket;
